<template>
    <v-modal-slot id="show-task-modal"
                  size="xl">
        <template v-slot:modal-title>
            Información de la tarea
        </template>

        <template v-slot:modal-content>
            <div class="row user-form">
                <div class="col-6 d-flex flex-column">
                    <div class="form-group">
                        <p class="fw-bold mb-1">Nombre*:</p>
                        <p class="mb-0">{{ selectedTask.name }}</p>
                    </div>

                    <div class="form-group flex-grow-1 d-flex flex-column">
                        <p class="fw-bold mb-1">Descripción*:</p>
                        <p class="mb-0">{{ selectedTask.description }}</p>
                    </div>

                    <div class="form-group">
                        <p class="fw-bold mb-1">Autor*:</p>
                        <p class="mb-0">{{ selectedTask.author ?  selectedTask.author.name + ' (' + selectedTask.author.email + ')' : '-' }}</p>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <p class="fw-bold mb-1">Tipo:</p>
                        <p class="mb-0"><span class="badge bg-dark">{{ selectedTask.type }}</span></p>
                    </div>

                    <div class="form-group">
                        <p class="fw-bold mb-1">Estado:</p>
                        <p class="mb-0"><span class="badge bg-success">{{ selectedTask.status }}</span></p>
                    </div>

                    <div class="form-group">
                        <p class="fw-bold mb-1">Origen*:</p>
                        <p class="mb-0"><span class="badge bg-info">{{ selectedTask.origin }}</span></p>
                    </div>

                    <div class="row">
                        <div class="form-group col-6">
                            <p class="fw-bold mb-1">Responsable:</p>
                            <p class="mb-0">{{ !!selectedTask.user ? selectedTask.user.name : '-' }}</p>
                        </div>

                        <div class="form-group col-6">
                            <p class="fw-bold mb-1">Equipo:</p>
                            <p class="mb-0">{{ !!selectedTask.role ? formatRoleName(selectedTask.role.name) : '-' }}</p>
                        </div>
                    </div>

                    <div class="form-group">
                        <p class="fw-bold mb-1">Fecha de finalización:</p>
                        <p class="mb-0">{{ !!selectedTask.end_date ? dateToReadable(selectedTask.end_date) : '-' }}</p>
                    </div>

                    <div class="row">
                        <div class="form-group col-6">
                            <p class="fw-bold mb-1">Cliente:</p>
                            <p class="mb-0">{{ !!selectedTask.client ? '#' + selectedTask.client.code + ' ' + selectedTask.client.name + ' ' + selectedTask.client.surname : '-' }}</p>
                        </div>

                        <div class="form-group col-6">
                            <p class="fw-bold mb-1">Expediente:</p>
                            <p class="mb-0">{{ !!selectedTask.expedient ? selectedTask.expedient.name : '-'}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </v-modal-slot>
</template>

<script>
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import VSelectJq from "../../general/VSelectJQ";
import VModalSlot from "../../general/VModalSlot";
import VPopover from "../../general/VPopover";

export default {
    name: "TasksListShowModal",
    props: {
        task: {
            type: Object,
            require: true,
        }
    },
    components: {
        VPopover,
        VModalSlot,
        VSelectJq,
        VModalValidated,
        Form,
        Field,
        ErrorMessage
    },
    computed: {
        user() {
            return this.$store.state.user.userLogged;
        }
    },
    data() {
        return {
            selectedTask: {},
        }
    },
    async mounted() {
        this.selectedTask = {...this.task};
    },
    methods: {
        formatRoleName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).replaceAll('_', ' ');
        },
        dateToReadable(date) {
            if (date) {
                let splitted = date.substr(0, 10).split('-');

                return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
